module.exports = __webpack_public_path__ + "img/Falkirk.5845f037.png";